var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.userClasses],attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"content",staticStyle:{"padding-top":"11rem"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }